/* Ferraz x Mason — ce que faisaient le JS du thème Shrine (main.js, sous licence, non repris) et les applis Kaching et
   Judge.me sur masonclothing.com, refait simplement :
   1. choix de couleur / pointure → bonne variante dans le formulaire, image de la variante, adresse ?variant= ;
   2. bloc d'offres (1 / 2 / 4 paires) → quantité ajoutée au panier ;
   3. barre d'achat collante (apparaît après le bouton, ramène au choix) ;
   4. étoiles Judge.me (badges) et widget d'avis (10 avis, « Ver mais », tri) d'après les données de la boutique.
   Écrit à la main ; source : mason/theme/assets/fz-mason.js. */
(function () {
  'use strict';

  /* ---------- 1. variantes ---------- */
  function variantesDe(vs) {
    var s = vs.querySelector('script[type="application/json"]');
    try { return JSON.parse(s.textContent); } catch (e) { return []; }
  }

  function optionsChoisies(vs) {
    var out = [];
    vs.querySelectorAll('.product-form__input').forEach(function (bloc) {
      var r = bloc.querySelector('input[type="radio"]:checked');
      if (r) { out.push(r.value); return; }
      var s = bloc.querySelector('select');
      if (s) out.push(s.value);
    });
    return out;
  }

  function appliquerVariante(vs, v) {
    if (!v) return;
    var section = vs.dataset.section;
    var formId = 'product-form-' + section;
    document.querySelectorAll('#' + CSS.escape(formId) + ' input[name="id"], input[name="id"][form="' + formId + '"]').forEach(function (i) {
      i.value = v.id;
      i.disabled = false;
      i.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (vs.closest('main') && document.querySelectorAll('variant-selects').length === 1) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
    }
    if (v.featured_media) {
      var g = document.getElementById('MediaGallery-' + section);
      var id = section + '-' + v.featured_media.id;
      if (g && typeof g.setActiveMedia === 'function' && g.querySelector('[data-media-id="' + id + '"]')) {
        try { g.setActiveMedia(id, false); } catch (e) {}
      }
    }
    var sel = document.querySelector('#StickyAtcVariantPicker-' + CSS.escape(section) + ' select');
    if (sel) {
      Array.prototype.forEach.call(sel.options, function (o) { o.selected = String(o.dataset.variantId) === String(v.id); });
    }
    document.dispatchEvent(new CustomEvent('fz:variante', { detail: { section: section, variante: v } }));
  }

  document.addEventListener('change', function (e) {
    var vs = e.target.closest && e.target.closest('variant-selects');
    if (vs) {
      var vars = variantesDe(vs);
      var opts = optionsChoisies(vs);
      var v = vars.find(function (x) { return x.options.every(function (o, k) { return o === opts[k]; }); });
      appliquerVariante(vs, v);
      return;
    }
    var sec = e.target.closest && e.target.closest('secondary-variant-select');
    if (sec && e.target.tagName === 'SELECT') {
      var opt = e.target.options[e.target.selectedIndex];
      var valeurs = (opt.dataset.options || '').split(',');
      var main = document.getElementById('variant-selects-' + sec.dataset.section);
      if (!main) return;
      main.querySelectorAll('.product-form__input').forEach(function (bloc, k) {
        var r = bloc.querySelector('input[type="radio"][value="' + CSS.escape(valeurs[k] || '') + '"]');
        if (r) r.checked = true;
        var s = bloc.querySelector('select');
        if (s) s.value = valeurs[k];
      });
      appliquerVariante(main, variantesDe(main).find(function (x) { return String(x.id) === String(opt.dataset.variantId); }));
    }
  }, true);

  /* ---------- 2. offres Kaching ---------- */
  function initOffres(kb) {
    var cfg = {};
    try { cfg = JSON.parse(kb.dataset.fzOffres || '{}'); } catch (e) {}
    var barras = cfg.barras || [];
    var zone = kb.parentElement;
    var form = zone && zone.querySelector('form[action$="/cart/add"]');
    if (!form) {
      var pf = kb.closest('product-info, .product__info-container, section');
      form = pf && pf.querySelector('form[action$="/cart/add"]');
    }
    function choisir(bar) {
      kb.querySelectorAll('.kaching-bundles__bar').forEach(function (b) {
        var on = b === bar;
        b.classList.toggle('kaching-bundles__bar--selected', on);
        var r = b.querySelector('input[type="radio"]');
        if (r) r.checked = on;
      });
      var c = barras.find(function (x) { return x.id === bar.dataset.dealBarId; });
      var q = c ? c.q : 1;
      if (!form) return;
      var qi = form.querySelector('input[name="quantity"]');
      if (!qi) {
        qi = document.createElement('input');
        qi.type = 'hidden';
        qi.name = 'quantity';
        form.appendChild(qi);
      }
      qi.value = q;
      majCollante(form, bar);
    }
    kb.addEventListener('click', function (e) {
      var bar = e.target.closest('.kaching-bundles__bar');
      if (bar) choisir(bar);
    });
    var pre = kb.querySelector('.kaching-bundles__bar--selected') ||
      kb.querySelector('.kaching-bundles__bar[data-deal-bar-id="' + cfg.pre + '"]') || kb.querySelector('.kaching-bundles__bar');
    if (pre) choisir(pre);
    pointuresParArticle(kb, form);
  }

  /* Offres avec une liste de pointures par article (semelles) : chaque liste ajoute sa pointure. Avant le 26/10, elles
     étaient ignorées et tout partait dans la 1re variante (39), la fiche n'ayant pas d'autre choix de pointure.
     La variante est retrouvée par son titre (39, 44–45…) ; « - Indisponível » (repris de Mason) est retiré quand la
     variante Ferraz est en vente. */
  function libelle(o) { return o.textContent.replace(/\s+-\s+Indisponível\s*$/, '').trim(); }

  function pointuresParArticle(kb, form) {
    var handle = kb.dataset.fzProduit;
    if (!handle || !form || !kb.querySelector('.kaching-bundles__bar select')) return;
    var parTitre = null;
    fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        parTitre = {};
        p.variants.forEach(function (v) { parTitre[v.title] = v; });
        kb.querySelectorAll('.kaching-bundles__bar select option').forEach(function (o) {
          var v = parTitre[libelle(o)];
          if (v && v.available) o.textContent = libelle(o);
        });
      })
      .catch(function () {});
    document.addEventListener('submit', function (e) {
      if (e.target !== form || !parTitre) return;
      var bar = kb.querySelector('.kaching-bundles__bar--selected');
      var listes = bar ? bar.querySelectorAll('select') : [];
      if (!listes.length) return;
      var items = [];
      for (var k = 0; k < listes.length; k++) {
        var o = listes[k].options[listes[k].selectedIndex];
        var v = o && parTitre[libelle(o)];
        if (!v) return;
        var deja = items.find(function (x) { return x.id === v.id; });
        if (deja) deja.quantity += 1; else items.push({ id: v.id, quantity: 1 });
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      var bouton = form.querySelector('[type="submit"]');
      if (bouton) { bouton.setAttribute('aria-disabled', 'true'); bouton.classList.add('loading'); }
      var tiroir = document.querySelector('cart-drawer');
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: tiroir ? tiroir.getSectionsToRender().map(function (s) { return s.id; }) : [],
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (r) {
          if (r.status) return;
          if (tiroir) {
            tiroir.classList.remove('is-empty');
            tiroir.renderContents(r);
          } else {
            window.location = window.routes.cart_url;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fz-pointures', cartData: r });
          }
        })
        .catch(function () {})
        .then(function () {
          if (bouton) { bouton.removeAttribute('aria-disabled'); bouton.classList.remove('loading'); }
        });
    }, true);
  }

  /* barre collante : prix de l'offre choisie (et son prix barré), pas celui d'une paire (Ayoub, 26/10) */
  function majCollante(form, bar) {
    var fid = form && form.getAttribute('id') || '';   // form.id renvoie le champ name="id" du formulaire
    var section = fid.indexOf('product-form-') === 0 ? fid.slice(13) : null;
    var st = section && document.querySelector('sticky-atc[data-section="' + section + '"]');
    var bloc = st && st.querySelector('.sticky-atc__price .price');
    var p = bar && bar.querySelector('.kaching-bundles__bar-price');
    if (!bloc || !p) return;
    var prix = p.textContent.trim();
    var f = bar.querySelector('.kaching-bundles__bar-full-price');
    var barre = f ? f.textContent.trim() : '';
    bloc.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach(function (e) { e.textContent = prix; });
    var s = bloc.querySelector('.price__compare-price s');
    if (s) s.textContent = barre;
    bloc.classList.toggle('price--on-sale', !!barre);
  }

  /* ---------- 3. barre d'achat collante ---------- */
  function initCollante(st) {
    var section = st.dataset.section;
    var bouton = document.getElementById('ProductSubmitButton-' + section);
    if (st.dataset.afterScroll === 'true' && bouton) {
      var maj = function () {
        var r = bouton.getBoundingClientRect();
        st.style.transform = r.bottom < 0 ? 'none' : '';
      };
      window.addEventListener('scroll', maj, { passive: true });
      maj();
    }
    var b = st.querySelector('.sticky-atc__scroll-btn');
    if (b) b.addEventListener('click', function (e) {
      e.preventDefault();
      var cible = document.getElementById('ProductInfo-' + section) || bouton;
      if (cible) window.scrollTo({ top: cible.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
    });
  }

  /* ---------- 4. avis ---------- */
  var MOD = null;
  function modeles() {
    if (!MOD) {
      var s = document.getElementById('fz-avis-modeles');
      try { MOD = JSON.parse(s.textContent); } catch (e) { MOD = null; }
    }
    return MOD;
  }

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function etoiles(n) {
    var m = modeles();
    var plein = m.etoile, vide = m.etoile.replace('', '');
    var out = '';
    for (var k = 1; k <= 5; k++) out += k <= n ? plein : vide;
    return out;
  }

  function reponses(c) {
    if (!c || !c.length) return '';
    var m = modeles(), tmp = document.createElement('div');
    tmp.innerHTML = m.cf;
    var curseurs = tmp.querySelectorAll('.jm-custom-answer-list__item');
    var gabCurseur = curseurs[0] ? curseurs[0].outerHTML : '';
    var gabEchelle = curseurs[1] ? curseurs[1].outerHTML : '';
    var multi = tmp.querySelector('.jm-multi-choice-answer');
    var gabMulti = multi ? multi.outerHTML : '';
    var texte = tmp.querySelector('.jm-text-answer');
    var gabTexte = texte ? texte.outerHTML : '';
    var haut = '', bas = '';
    c.forEach(function (r) {
      var d = document.createElement('div');
      if (r.t === 'slider' && gabCurseur) {
        d.innerHTML = gabCurseur;
        var p = d.querySelectorAll('p');
        if (p[0]) p[0].textContent = r.q;
        if (p[1]) p[1].textContent = r.lo;
        if (p[2]) p[2].textContent = r.hi;
        var ind = d.querySelector('.jm-progress-bar__indicator');
        if (ind) ind.style.left = (parseFloat(r.v) || 0) + '%';
        haut += d.innerHTML;
      } else if (r.t === 'scale' && gabEchelle) {
        d.innerHTML = gabEchelle;
        var q = d.querySelectorAll('p');
        if (q[0]) q[0].textContent = r.q;
        if (q[1]) q[1].textContent = r.v;
        if (q[2]) q[2].textContent = r.lo;
        if (q[3]) q[3].textContent = r.hi;
        var fill = d.querySelector('.jm-progress-bar__fill');
        var parts = String(r.v).split('/');
        if (fill && parts.length === 2) fill.style.width = (100 * parseFloat(parts[0]) / parseFloat(parts[1])) + '%';
        haut += d.innerHTML;
      } else if (r.t === 'multiple' && gabMulti) {
        d.innerHTML = gabMulti;
        var mp = d.querySelectorAll('p');
        if (mp[0]) mp[0].textContent = r.q;
        if (mp[1]) mp[1].innerHTML = r.v.map(function (x, k) {
          return '<span class="jm-answer-item">' + esc(x) + (k < r.v.length - 1 ? ', ' : '') + '</span>';
        }).join('');
        bas += d.innerHTML;
      } else if (r.v && gabTexte) {
        d.innerHTML = gabTexte;
        var tp = d.querySelectorAll('p');
        if (tp[0]) tp[0].textContent = r.q;
        if (tp[1]) tp[1].textContent = r.v;
        bas += d.innerHTML;
      }
    });
    var cl = tmp.querySelector('.jm-custom-answer-list__content > .jm-cluster');
    if (cl) cl.innerHTML = haut;
    var lst = tmp.querySelector('.jm-custom-answer-list__content > .jm-stack');
    if (lst) lst.innerHTML = bas;
    if (!haut && cl) cl.remove();
    return tmp.innerHTML;
  }

  function photos(p) {
    if (!p || !p.length) return '';
    return '<div class="fz-avis__photos">' + p.map(function (u) {
      return '<a href="' + esc(u) + '?width=1024" target="_blank" rel="noopener"><img src="' + esc(u) + '?width=240" alt="" loading="lazy"></a>';
    }).join('') + '</div>';
  }

  function avisHTML(a) {
    var m = modeles();
    var vb = m.item.match(/⟪vb:([\s\S]*?)⟫/);
    var corps = (a.ti ? '<p><strong>' + esc(a.ti) + '</strong></p>' : '') + (a.b || '') + photos(a.p);
    return m.item
      .replace('⟪u⟫', esc(a.u))
      .replace('⟪r⟫', a.r)
      .replace('⟪etoiles⟫', etoiles(a.r))
      .replace(/⟪n⟫/g, esc(a.n))
      .replace(/⟪vb:[\s\S]*?⟫/, a.vb && vb ? vb[1] : '')
      .replace('⟪d⟫', esc(a.d))
      .replace('⟪b⟫', corps)
      .replace('⟪cf⟫', reponses(a.c));
  }

  function trier(a, mode) {
    var t = a.slice();
    if (mode === 'highest_rating') t.sort(function (x, y) { return y.r - x.r || (y.ts > x.ts ? 1 : -1); });
    else if (mode === 'lowest_rating') t.sort(function (x, y) { return x.r - y.r || (y.ts > x.ts ? 1 : -1); });
    else if (mode === 'with_pictures') t = t.filter(function (x) { return x.p && x.p.length; });
    else if (mode === 'pictures_first' || mode === 'videos_first') t.sort(function (x, y) { return (y.p.length ? 1 : 0) - (x.p.length ? 1 : 0); });
    else if (mode === 'most_helpful') t.sort(function (x, y) { return (y.h || 0) - (x.h || 0); });
    return t;
  }

  function entete(w, d) {
    var moy = (Math.round(parseFloat(d.m) * 10) / 10).toFixed(1).replace('.', ',');
    var disp = w.querySelector('.jm-average-rating-display');
    if (disp) {
      var p = disp.querySelectorAll('p');
      if (p[0]) p[0].textContent = moy;
      if (p[1]) p[1].textContent = d.n + ' avaliações';
    }
    var tot = d.h.reduce(function (s, x) { return s + x; }, 0) || 1;
    w.querySelectorAll('.jm-histogram-row').forEach(function (row, k) {
      var f = d.h[k] || 0, pc = Math.round(100 * f / tot);
      var fill = row.querySelector('.jm-progress-bar__fill');
      if (fill) fill.style.width = pc + '%';
      var fr = row.querySelector('.jm-histogram-row__frequency');
      if (fr) fr.textContent = f;
      row.setAttribute('aria-label', pc + '% (' + f + ') avaliações com ' + (5 - k) + ' estrelas');
    });
    var grille = w.querySelector('.jm-media-grid__container');
    if (grille) {
      var ph = [];
      d.a.forEach(function (a) { (a.p || []).forEach(function (u) { if (ph.length < 10) ph.push(u); }); });
      var items = grille.querySelectorAll('.jm-media-grid__item');
      items.forEach(function (it, k) {
        var img = it.querySelector('img');
        if (k >= ph.length) { it.remove(); return; }
        it.classList.remove('jm-media-grid__item--loading');
        var ld = it.querySelector('.jm-media-grid__loading');
        if (ld) ld.remove();
        if (img) { img.src = ph[k] + '?width=240'; img.removeAttribute('srcset'); }
        it.addEventListener('click', function () { window.open(ph[k] + '?width=1024', '_blank'); });
      });
      if (!ph.length) { var mp = w.querySelector('.jm-media-preview'); if (mp) mp.remove(); }
      w.querySelectorAll('.jm-media-grid').forEach(function (g) { g.classList.remove('jm-media-grid--loading'); });
    }
  }

  function initAvis(box) {
    var src = box.dataset.src;
    if (!src || !modeles()) return;
    fetch(src).then(function (r) { return r.json(); }).then(function (d) {
      entete(box, d);
      var liste = box.querySelector('.jdgm-review-list');
      var plus = box.querySelector('.jm-load-more-pagination button, button[aria-label="Ver mais avaliações"]');
      var tri = box.querySelector('select.jm-sort-filter__select');
      var vus = 0, ordre = trier(d.a, 'created_at');
      function afficher(n) {
        var html = '';
        ordre.slice(vus, vus + n).forEach(function (a) { html += avisHTML(a); });
        liste.insertAdjacentHTML('beforeend', html);
        vus = Math.min(ordre.length, vus + n);
        if (plus) plus.closest('nav').style.display = vus >= ordre.length ? 'none' : '';
      }
      afficher(10);
      if (plus) plus.addEventListener('click', function () { afficher(10); });
      if (tri) tri.addEventListener('change', function () {
        ordre = trier(d.a, tri.value);
        liste.innerHTML = '';
        vus = 0;
        afficher(10);
      });
      box.addEventListener('click', function (e) {
        var ec = e.target.closest('[data-testid="write-review-button"]');
        if (ec) { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'pages/contact'; }
        var lerMais = e.target.closest('.jm-review-content__body');
        if (lerMais) lerMais.style.webkitLineClamp = lerMais.style.webkitLineClamp === 'unset' ? '5' : 'unset';
      });
      box.querySelectorAll('.jm-histogram-row').forEach(function (row, k) {
        row.addEventListener('click', function () {
          ordre = trier(d.a, 'created_at').filter(function (a) { return a.r === 5 - k; });
          liste.innerHTML = '';
          vus = 0;
          afficher(10);
        });
      });
    }).catch(function () {});
  }

  function initBadges() {
    document.querySelectorAll('.jdgm-prev-badge').forEach(function (b) {
      var n = parseInt(b.dataset.numberOfReviews || '0', 10);
      if (!n) return;
      b.style.display = '';
      var w = b.closest('.jdgm-widget');
      if (w) w.classList.add('jdgm--done-setup');
      var t = b.querySelector('.jdgm-prev-badge__text');
      if (t && !/avalia/.test(t.textContent)) t.textContent = n + ' avaliações';
      var s = b.querySelector('.jdgm-prev-badge__stars');
      if (s) s.addEventListener('click', function () {
        var av = document.querySelector('.fz-avis');
        if (av) av.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }

  /* ---------- 5. variante épuisée ---------- */
  /* Le JSON des variantes de la page vient du site US (tout y est « disponible ») : le vrai stock est lu sur
     /products/<fiche>.js. Variante épuisée dans Shopify → bouton « Esgotado » terne et sans clic, dans le formulaire
     et dans la barre collante (Ayoub, 29/10 : Meias Táticas castanho coiote). */
  var STOCK = null;

  function majStock(section, id) {
    if (!STOCK || !section) return;
    var ko = STOCK[String(id)] === false;
    var st = document.querySelector('sticky-atc[data-section="' + section + '"]');
    [document.getElementById('ProductSubmitButton-' + section), st && st.querySelector('.sticky-atc__scroll-btn')]
      .forEach(function (b) {
        if (!b) return;
        var t = b.querySelector('.main-atc__label__text, .sticky-atc__label__text');
        if (t) {
          if (t.dataset.fzTexte === undefined) t.dataset.fzTexte = t.textContent;
          t.textContent = ko ? ((window.variantStrings && window.variantStrings.soldOut) || 'Esgotado') : t.dataset.fzTexte;
        }
        b.classList.toggle('fz-esgotado', ko);
        if (ko) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
        if (b.type === 'submit') b.disabled = ko;
      });
  }

  function initStock() {
    var m = /\/products\/([^\/?#]+)/.exec(window.location.pathname);
    var vs = document.querySelector('main variant-selects');
    if (!m || !vs) return;
    var section = vs.dataset.section;
    document.addEventListener('fz:variante', function (e) { majStock(e.detail.section, e.detail.variante.id); });
    // garde-fou : rien ne part au panier si la variante du formulaire est épuisée
    document.addEventListener('submit', function (e) {
      var i = e.target.querySelector && e.target.querySelector('input[name="id"]');
      if (STOCK && i && STOCK[String(i.value)] === false) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
    fetch(window.Shopify.routes.root + 'products/' + m[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        STOCK = {};
        p.variants.forEach(function (v) { STOCK[String(v.id)] = v.available; });
        var i = document.querySelector('#product-form-' + CSS.escape(section) + ' input[name="id"], input[name="id"][form="product-form-' + section + '"]');
        if (!i) return;
        // à l'arrivée, une variante épuisée laisse la place à la première en vente, même pointure si possible
        // (Ayoub, 29/10 : Meias Táticas → noir par défaut, la brune étant épuisée)
        var vars = variantesDe(vs);
        var v0 = vars.find(function (x) { return String(x.id) === String(i.value); });
        if (v0 && STOCK[String(v0.id)] === false) {
          var enVente = vars.filter(function (x) { return STOCK[String(x.id)] !== false; });
          var v = enVente.find(function (x) {
            return x.options.slice(1).every(function (o, k) { return o === v0.options[k + 1]; });
          }) || enVente[0];
          if (v) {
            vs.querySelectorAll('.product-form__input').forEach(function (bloc, k) {
              var r = bloc.querySelector('input[type="radio"][value="' + CSS.escape(v.options[k] || '') + '"]');
              if (r) r.checked = true;
            });
            appliquerVariante(vs, v);
            return;
          }
        }
        majStock(section, i.value);
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('kaching-bundle[data-fz-offres]').forEach(initOffres);
    document.querySelectorAll('sticky-atc').forEach(initCollante);
    initStock();
    document.querySelectorAll('.fz-avis[data-src]').forEach(initAvis);
    initBadges();
    var p = new URLSearchParams(window.location.search).get('variant');
    if (p) {
      document.querySelectorAll('variant-selects').forEach(function (vs) {
        var v = variantesDe(vs).find(function (x) { return String(x.id) === p; });
        if (!v) return;
        vs.querySelectorAll('.product-form__input').forEach(function (bloc, k) {
          var r = bloc.querySelector('input[type="radio"][value="' + CSS.escape(v.options[k] || '') + '"]');
          if (r) r.checked = true;
        });
        appliquerVariante(vs, v);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
